import axios from 'axios';

import ApiService from 'services/network/ApiService';

import { ITableParams } from 'common/interfaces/table';
import { IBilling } from 'common/components/PersonProfile/interfaces';
import { IObject } from 'common/interfaces/common';
import { IAttachmentImt } from 'common/interfaces/uploadFile';

export default class BillingScheduleService extends ApiService {
  public getPersonBillingSchedule = (
    personId: number,
    requestOptions: ITableParams,
  ): Promise<IBilling> => {
    const searchParams = this.getSearchFromTableParams(requestOptions);

    return axios.get(`/api/v1/front-desk/${personId}/billing-schedules`, { params: searchParams });
  };

  public updateBillingScheduleAmount = (
    personId: number,
    billingItemId: string,
    amount: number,
  ): Promise<IBilling> =>
    axios.patch(`/api/v1/front-desk/${personId}/billing-schedules/${billingItemId}`, {
      amount,
    });

  public exportScheduledBillingsReport = (
    exportData: IObject,
    params: ITableParams,
  ): Promise<IAttachmentImt> => {
    const searchParams = this.getSearchFromTableParams(params);

    searchParams.perPage = 0;
    searchParams.page = 0;

    return axios.get('/api/v1/reports/billing/export', {
      params: searchParams,
    });
  };
}
